/*
 * Copyright (c) 2022. Revo Digital
 * ---
 * Author: gabriele
 * File: OriginTypeSection.tsx
 * Project: mle-client-n
 * Committed last: 2022/5/18 @ 1841
 * ---
 * Description:
 */

import { IDataRef }                from '@revodigital/mpes';
import { useState }                from 'react';
import { Collapse, Icon, Spinner } from '@blueprintjs/core';
import { FieldIndicator }          from './FieldIndicator';
import { observer }                from 'mobx-react';
import { HasEditor }               from '../../../common/props';

export interface Props extends HasEditor {
  title: string;
  bottomButton?: JSX.Element;
  data: RefData[];
  isLoading: boolean;
  itemRenderer?: (data: RefData) => JSX.Element;
}

export interface RefData {
  ref: IDataRef,
  value: string;
}

export const OriginTypeSection = observer((props: Props) => {
  const [isOpened, setIsOpened] = useState(false);

  const defaultItemRenderer = (it: RefData) => <FieldIndicator
    editor={ props.editor }
    refData={ it }/>;

  return <div className="my-2 bg-bpdark-200">
    <div
      className="flex w-full flex-row p-2 justify-between hover:bg-bpdark-100 cursor-pointer"
      onClick={ () => setIsOpened(!isOpened)
      }>
      <div className="font-bold">{ props.title }</div>
      <Icon icon={ !isOpened ? 'caret-right' : 'caret-down' }/>
    </div>
    <Collapse isOpen={ isOpened } className="p-1">
      { !props.isLoading ?
        <div className="divide-solid divide-y divide-white divide-opacity-10">
          { props.data.length > 0 &&
            props.data.map(props.itemRenderer || defaultItemRenderer)
          }
        </div> : <Spinner size={ 20 } className="m-3"/> }
      {
        props.bottomButton
      }
    </Collapse>
  </div>;
});
